import ReactDOM from 'react-dom';
import { ReactComponent as Exit } from '../../assets/icons/exit.svg';
import { ReactComponent as Eye } from '../../assets/icons/Eye.svg';
import { ReactComponent as Delete } from '../../assets/icons/Delete.svg';
import { checkMatchQuestionForTest, checkMatchQuestionMixed, checkMatchQuestionURL, clearStoredUserSession, formatQuizEndDescription, formatQuizShowResultDateTime, getAnswerFiles, getDisplayFileName, getMixedQuestionCounts, getQuizTypeLabel, getSessionToken, getStoredUserSession, isGuestSession, isTestQuestion, safeParseLocalStorageJson } from '../../assets/utils/utils';
import { attemptToJoinExam, deleteFile, examDatails, getCurrentAttempt, getSchoolName, guestVerification, logoutUser } from '../../assets/api/userActions';
import RemoteFilePreviewModal from '../../components/modal/remoteFilePreviewModal';
import Swal from 'sweetalert2';
import classes from '../../App.module.scss';
import { useState, useEffect, useCallback } from 'react';
import { tryEnterExamWithStoredToken } from '../../assets/utils/redirectAfterGuestLogin';
import { showAttemptJoinErrorSwal } from '../../assets/utils/attemptJoinErrorSwal';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loading from '../../components/loading/loading';
import { ExamInfoCountdown } from '../../components/countDown/countDown';
import PreviewUploadButtons from '../../components/previewAnswerButtons/descriptiveUploadButtons/previewUplaodButton';
import TestCheckboxPreviewButtons from '../../components/previewAnswerButtons/testCheckboxButtons/testCheckboxPreviewButtons';

function ExamInfo() {

    const [searchParams] = useSearchParams();
    const params = useParams();
    const navigate = useNavigate();
    const [verify, setVerify] = useState();
    const [schoolName, setSchoolName] = useState("");
    const [examData, setExamData] = useState();
    const [isUserLogged, setIsUserLogged] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isJoinExamLoading, setIsJoinExamLoading] = useState(false)
    const [currentAttempt, setCurrentAttempt] = useState(null)
    const [attemptQuizData, setAttemptQuizData] = useState(null)
    const [userAnswered, setUserAnswered] = useState(null)
    const [selectedQuestionAnswer, setSelectedQuestionAnswer] = useState(null)
    const [activePreviewBtn, setActivePreviewBtn] = useState(null)
    const [previewFile, setPreviewFile] = useState(null)
    const isGuestLink = Boolean(searchParams.get("_id") && searchParams.get("_token"));

    const isUnauthenticatedResponse = (response) => response?.message === "Unauthenticated.";

    /**
     * در صورت کشف Unauthenticated:
     * - اگر آزمون غیرفعال است، پیام «آزمون غیرفعال است» نمایش داده می‌شود
     *   تا کاربر اشتباهاً تصور نکند نشست او منقضی شده است.
     * - برای کاربر مهمان (که حساب کاربری ندارد) به جای «ورود به حساب کاربری»،
     *   پیام عمومی نمایش داده می‌شود و به صفحهٔ ورود مهمان هدایت می‌شود.
     */
    const redirectToLogin = useCallback((showMessage = true) => {
        const storedParsed = safeParseLocalStorageJson("userToken");
        const looksLikeGuest = isGuestSession(storedParsed);
        const guestAllowed = Boolean(verify?.guest ?? examData?.guest);
        const isExamInactive = examData?.active === 0;

        clearStoredUserSession();
        setIsUserLogged(false);
        setCurrentAttempt(null);
        setAttemptQuizData(null);

        const goToLogin = () => {
            if (looksLikeGuest && guestAllowed) {
                navigate(`/auth/login/guest/${params.quiz}`);
            } else {
                navigate(`/auth/login/${params.quiz}`);
            }
        };

        if (!showMessage) {
            goToLogin();
            return;
        }

        if (isExamInactive) {
            Swal.fire({
                rtl: true,
                icon: "warning",
                iconColor: "#d97706",
                title: "این آزمون در حال حاضر غیرفعال است",
                text: "برای فعال‌سازی یا اطلاع از زمان برگزاری، لطفاً با مجموعهٔ برگزارکنندهٔ آزمون هماهنگ بفرمایید.",
                confirmButtonText: "متوجه شدم",
                confirmButtonColor: "#64748b",
            }).then(() => goToLogin());
            return;
        }

        if (looksLikeGuest) {
            Swal.fire({
                rtl: true,
                icon: "info",
                title: "نشست مهمان شما به پایان رسیده است",
                text: "برای ادامه، لطفاً مجدداً به عنوان مهمان وارد شوید.",
                confirmButtonText: "باشه",
            }).then(() => goToLogin());
            return;
        }

        Swal.fire({
            icon: "info",
            title: "نشست شما منقضی شده است",
            text: "لطفا دوباره وارد حساب کاربری شوید.",
            confirmButtonText: "باشه",
        }).then(() => goToLogin());
    }, [navigate, params.quiz, examData?.active, examData?.guest, verify?.guest]);


    const validExamHandler = useCallback((data) => {
        if (!data.validation) {
            navigate("/service/not-active");
        }
    }, [navigate]);

    /** پیام خطای شروع آزمون؛ برای عدم عضویت، ظاهر حرفه‌ای + دکمهٔ مهمان در صورت فعال بودن */
    const showAttemptJoinError = (res) => {
        const isNotMember = res?.status === "not-member";
        const guestAllowed = Boolean(verify?.guest ?? examData?.guest);

        if (isNotMember) {
            const stored = safeParseLocalStorageJson("userToken");
            const looksLikeGuest = isGuestSession(stored);

            const goToGuestLogin = () => {
                clearStoredUserSession();
                navigate(`/auth/login/guest/${params.quiz}`);
            };
            const goToUserLogin = () => {
                clearStoredUserSession();
                navigate(`/auth/login/${params.quiz}`);
            };

            const detailHtml = String(res?.message ?? "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");

            const swalOptions = {
                rtl: true,
                icon: "warning",
                iconColor: "#d97706",
                title: "دسترسی به این آزمون برای حساب شما فعال نیست",
                html: `
                    <div style="text-align:right;">
                        <p style="margin:0 0 14px;font-size:15px;line-height:1.8;color:#334155;">
                            حسابی که با آن وارد شده‌اید در <strong>فهرست شرکت‌کنندگان</strong> این آزمون ثبت نشده است.
                            اگر قبلاً در آزمون دیگری شرکت کرده‌اید، نشست شما به آن آزمون مربوط است؛ برای ورود به این آزمون از گزینه‌های زیر استفاده کنید.
                        </p>
                        ${
                            guestAllowed
                                ? `<p style="margin:0 0 14px;font-size:14px;line-height:1.75;color:#115e59;background:linear-gradient(135deg,#ecfdf5 0%,#d1fae5 100%);border-radius:12px;padding:14px 16px;border:1px solid #6ee7b7;">
                                    برای این آزمون، <strong>ورود مهمان</strong> فعال است؛ می‌توانید با دکمهٔ «ورود به عنوان مهمان» وارد شوید.
                                   </p>`
                                : ""
                        }
                        <p style="margin:0;font-size:13px;line-height:1.65;color:#64748b;padding-top:10px;border-top:1px solid #e2e8f0;">
                            ${detailHtml}
                        </p>
                    </div>
                `,
                confirmButtonText: "متوجه شدم",
                confirmButtonColor: "#64748b",
                reverseButtons: true,
                customClass: { popup: "exam-join-dialog-popup" },
            };

            if (looksLikeGuest && guestAllowed) {
                swalOptions.showCancelButton = true;
                swalOptions.cancelButtonText = "ورود به عنوان مهمان جدید";
                swalOptions.cancelButtonColor = "#0d9488";
                swalOptions.focusCancel = true;
            } else if (!looksLikeGuest) {
                swalOptions.showCancelButton = true;
                swalOptions.cancelButtonText = "ورود با حساب دیگر";
                swalOptions.cancelButtonColor = "#0369a1";
                if (guestAllowed) {
                    swalOptions.showDenyButton = true;
                    swalOptions.denyButtonText = "ورود به عنوان مهمان";
                    swalOptions.denyButtonColor = "#0d9488";
                    swalOptions.focusDeny = true;
                }
            }

            Swal.fire(swalOptions).then((result) => {
                if (result.isDenied) {
                    goToGuestLogin();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    if (looksLikeGuest && guestAllowed) {
                        goToGuestLogin();
                    } else {
                        goToUserLogin();
                    }
                }
            });
            return;
        }

        showAttemptJoinErrorSwal(res);
    };

    const fetchGuestValidation = useCallback(async () => {
        await guestVerification(params.quiz).then((res) => {
            setVerify(res);
            validExamHandler(res);
        });
    }, [params.quiz, validExamHandler]);

    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);

    const fetchData = useCallback(async () => {
        const data = await examDatails(params.quiz);
        if (data.status === "not-found") {
            Swal.fire({
                icon: "error",
                title: `${data.message}`,
            });
        } else {
            setExamData(data?.quiz);
            setIsLoading(false);
            return data?.quiz?.title;
        }
    }, [params.quiz]);

    const fetchCurrentAttempt = useCallback(async () => {
        const LSdata = getStoredUserSession({ quizCode: params.quiz });
        if (!getSessionToken(LSdata)) return null;
        if (!['descriptive', 'test', 'mixed'].includes(examData?.type)) return null;
        const result = await getCurrentAttempt(params.quiz);
        if (isUnauthenticatedResponse(result)) {
            redirectToLogin();
            return null;
        }
        if (result?.status === "success" && result?.attempt) {
            setCurrentAttempt(result.attempt);
            setAttemptQuizData(result.quiz || null);
            if (result.quiz && result.attempt?.answers) {
                if (examData?.type === "mixed") {
                    const newUserAnswered = checkMatchQuestionMixed(result.quiz, result.attempt);
                    setUserAnswered(newUserAnswered);
                    return newUserAnswered;
                } else if (examData?.type === "descriptive") {
                    const newUserAnswered = checkMatchQuestionURL(result.quiz, result.attempt);
                    setUserAnswered(newUserAnswered);
                    return newUserAnswered;
                } else if (examData?.type === "test") {
                    setUserAnswered(checkMatchQuestionForTest(result.quiz, result.attempt));
                }
            }
        } else {
            setAttemptQuizData(null);
        }
        return null;
    }, [examData?.type, params.quiz, redirectToLogin]);


    useEffect(() => {
        const tomorrow = new Date();
        tomorrow.setDate(new Date().getDate() + 1);
        const expireDate = tomorrow.getTime();

        const paramsID = searchParams.get("_id");
        const paramsToken = searchParams.get("_token");
        const paramsName = searchParams.get("_name");
        const queryToken = {
            quizToken: paramsToken,
            user_id: paramsID,
            name: paramsName,
            role: "guest",
            quizCode: params.quiz,
            expireDate,
        };
        const data = getStoredUserSession({ quizCode: params.quiz });
        if (paramsID && paramsToken) {
            localStorage.setItem("userToken", JSON.stringify(queryToken));
            setIsUserLogged(true);
        } else {
            if (data) {
                setIsUserLogged(true);
            } else {
                setIsUserLogged(false);
            }
        }
        fetchGuestValidation();
        fetchSchoolName();
        const examTitle = fetchData();
        examTitle.then((res) => (document.title = res === undefined ? `اطلاعات آزمون وجود ندارد` : `اطلاعات آزمون ${res}`));
    }, [
        searchParams,
        params.quiz,
        navigate,
        fetchGuestValidation,
        fetchSchoolName,
        fetchData,
    ]);

    useEffect(() => {
        if (isUserLogged && (examData?.type === "descriptive" || examData?.type === "test" || examData?.type === "mixed") && params.quiz) {
            fetchCurrentAttempt();
        }
    }, [isUserLogged, examData?.type, params.quiz, fetchCurrentAttempt]);
    const LS_data = getStoredUserSession({ quizCode: params.quiz, clearInvalid: false });

    /** نام نمایشی کاربر در سربرگ آزمون - برای جلوگیری از نمایش undefined */
    const headerDisplayName = (() => {
        if (!isUserLogged || !LS_data) return "وارد نشده";
        const name = (LS_data.name ?? "").toString().trim();
        return name || "کاربر مهمان";
    })();
    /** نام شرکت‌کننده در باکس اطلاعات آزمون */
    const participantDisplayName = (() => {
        if (!isUserLogged || !LS_data) return "وارد نشده‌اید";
        const name = (LS_data.name ?? "").toString().trim();
        return name || "کاربر مهمان (نام ثبت نشده)";
    })();
    const answerSheetQuestions = attemptQuizData?.questions || examData?.questions || [];
    const mixedQuestionCounts = examData?.type === "mixed" ? getMixedQuestionCounts(answerSheetQuestions) : null;
    // const inputHandler = (e) => {
    //     setInputField({ ...inputField, [e.target.name]: e.target.value });
    // }




    const handleResultShow = () => {
        if (examData?.show_result === "range") {
            const fromLine = formatQuizShowResultDateTime(examData?.show_result_from);
            const toLine = formatQuizShowResultDateTime(examData?.show_result_to);
            return <>
                {fromLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تستی  از تاریخ:</p>
                        <p className={classes.examInfo__detail}>{fromLine}</p>
                    </div>
                ) : null}
                {toLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تستی  تا تاریخ:</p>
                        <p className={classes.examInfo__detail}>{toLine}</p>
                    </div>
                ) : null}
                {!toLine && fromLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تا:</p>
                        <p className={classes.examInfo__detail}>بدون محدودیت زمانی برای پایان نمایش</p>
                    </div>
                ) : null}
            </>;
        }
        if (examData?.show_result === "no_display") {
            return (
                <div className={classes.examInfo__info_container}>
                    <p className={classes.examInfo__title}>نمایش کارنامه تستی:</p>
                    <p className={classes.examInfo__detail}>عدم نمایش</p>
                </div>
            );
        }
        return (
            <div className={classes.examInfo__info_container}>
                <p className={classes.examInfo__title}>نمایش کارنامه تستی:</p>
                <p className={classes.examInfo__detail}>پس از اتمام آزمون</p>
            </div>
        );
    };

    const getQuestionOrderText = () => {
        const orderMode = examData?.questions_order_mode || (examData?.random_questions ? "random" : "default");
        return orderMode === "random" ? "تصادفی" : "به ترتیب ثبت سوالات";
    };

    const getQuestionDisplayText = () => {
        const displayMode = examData?.questions_display_mode || "all_at_once";
        return displayMode === "one_by_one" ? "تکی (هر بار یک سوال)" : "یکجا (همه سوالات)";
    };

    const getNavigationText = () => {
        const displayMode = examData?.questions_display_mode || "all_at_once";
        if (displayMode !== "one_by_one") return "نمایش یکجا (ناوبری سوال-به-سوال ندارد)";
        const navMode = examData?.question_navigation_mode || "free";
        return navMode === "forward_only" ? "فقط جلو (بدون امکان بازگشت)" : "آزاد (قبلی/بعدی)";
    };

    // const onSubmitHandler = async (e) => {
    //     e.preventDefault();
    //     const userData = await userLogin(inputField);
    //     // console.log(userData);
    //     var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
    //     if (inputField.phone.length !== 11 && inputField.phone.length !== 0) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "شماره وارد شده صحیح نمیباشد",
    //             confirmButtonText: "باشه"

    //         })
    //     }
    //     else if (!inputField.phone.length) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "شماره خود را وارد کنید",
    //             confirmButtonText: "باشه"
    //         })
    //     }
    //     else if (!regex.test(inputField.phone.toString())) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "فرمت شماره وارد شده صحیح نمیباشد",
    //             confirmButtonText: "باشه"

    //         })
    //     }
    //     else if (userData.customCode) {
    //         Swal.fire({
    //             icon: "error",
    //             title: `${userData.error}`,
    //         })
    //     }
    //     else {
    //         const { token, ...newUserData } = userData;
    //         localStorage.setItem("userToken", JSON.stringify({
    //             ...newUserData, userToken: token, "expireDate": setExpireDate
    //         }))
    //         window.location.reload();
    //     }

    // }


    const handleGuestEntryClick = useCallback(async () => {
        if (isJoinExamLoading) return;
        const tokenData = getStoredUserSession({ quizCode: params.quiz });
        if (!tokenData) {
            navigate(`/auth/login/guest/${params.quiz}`);
            return;
        }
        setIsJoinExamLoading(true);
        try {
            const result = await tryEnterExamWithStoredToken(navigate, params.quiz);
            if (result?.entered) return;

            const joinRes = result?.joinResult;
            if (joinRes?.message === "Unauthenticated.") {
                redirectToLogin();
                return;
            }
            if (joinRes?.status === 'attempt-finished') {
                showAttemptJoinError(joinRes);
                await fetchCurrentAttempt();
                return;
            }
            if (joinRes && joinRes?.status !== "joined") {
                showAttemptJoinError(joinRes);
                return;
            }
            navigate(`/auth/login/guest/${params.quiz}`);
        } finally {
            setIsJoinExamLoading(false);
        }
    }, [isJoinExamLoading, navigate, params.quiz, redirectToLogin]);

    const examPageHandler = async () => {
        const data = getStoredUserSession({ quizCode: params.quiz });
        if (!data) {
            navigate('/auth/login/' + params.quiz);
            return;
        }
        if (isJoinExamLoading) return;
        setIsJoinExamLoading(true);
        try {
            const res = await attemptToJoinExam(params.quiz, getSessionToken(data));
            if (isUnauthenticatedResponse(res)) {
                redirectToLogin();
                return;
            }
            if (res?.status === 'attempt-finished') {
                showAttemptJoinError(res);
                await fetchCurrentAttempt();
                return;
            }
            if (res?.status !== 'joined' || res === undefined) {
                showAttemptJoinError(res);
                return;
            }
            if (examData?.type === 'test' && examData?.question_type === 'custom') {
                navigate(`/quiz/test/${params.quiz}`);
                window.location.reload();
            }
            if (examData?.type === 'mixed' && examData?.question_type === 'custom') {
                navigate(`/quiz/mixed/${params.quiz}`);
                window.location.reload();
            }
            if (examData?.type === 'test' && examData?.question_type === 'pdf') {
                navigate(`/quiz/test-pdf/${params.quiz}`);
                window.location.reload();
            }
            if (examData?.type === 'descriptive' && examData?.question_type === 'custom') {
                navigate(`/quiz/descriptive/${params.quiz}`);
                window.location.reload();
            }
            if (examData?.type === 'descriptive' && examData?.question_type === 'pdf') {
                navigate(`/quiz/descriptive-pdf/${params.quiz}`);
                window.location.reload();
            }
        } finally {
            setIsJoinExamLoading(false);
        }
    };

    const handleLogout = useCallback(async () => {
        const session = getStoredUserSession({ quizCode: params.quiz, clearInvalid: false });
        if (!session) return;
        const guest = isGuestSession(session);
        const result = await Swal.fire({
            rtl: true,
            icon: "question",
            iconColor: "#64748b",
            title: "خروج از حساب کاربری",
            html: `
                <div style="text-align:right;font-size:15px;line-height:1.8;color:#334155;">
                    <p style="margin:0 0 10px;">با خروج، نشست فعلی شما در این مرورگر حذف می‌شود.</p>
                    <p style="margin:0;font-size:14px;color:#64748b;">برای ورود دوباره به آزمون باید ${guest ? "اطلاعات مهمان خود را مجدداً وارد کنید" : "با حساب کاربری خود دوباره وارد شوید"}.</p>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: "بله، خارج شوم",
            cancelButtonText: "انصراف",
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#64748b",
            reverseButtons: true,
        });
        if (!result.isConfirmed) return;
        await logoutUser();
        clearStoredUserSession();
        setIsUserLogged(false);
        setCurrentAttempt(null);
        setAttemptQuizData(null);
        navigate(guest ? `/auth/login/guest/${params.quiz}` : `/auth/login/${params.quiz}`, { replace: true });
    }, [navigate, params.quiz]);

    const handleFileDelete = async (file) => {
        const confirmed = await Swal.fire({
            icon: 'warning',
            title: 'حذف فایل',
            text: `آیا از حذف "${getDisplayFileName(file)}" اطمینان دارید؟`,
            showCancelButton: true,
            confirmButtonText: 'بله، حذف شود',
            cancelButtonText: 'انصراف',
        });
        if (!confirmed.isConfirmed) return;
        try {
            const res = await deleteFile(file.id);
            if (res) {
                const newUserAnswered = await fetchCurrentAttempt();
                if (newUserAnswered && selectedQuestionAnswer) {
                    const updated = newUserAnswered.find(a => a.id === selectedQuestionAnswer.id);
                    if (updated) {
                        setSelectedQuestionAnswer({ ...selectedQuestionAnswer, ...updated });
                    } else {
                        setSelectedQuestionAnswer(null);
                        setActivePreviewBtn(null);
                    }
                }
                Swal.fire({ icon: 'success', title: 'فایل با موفقیت حذف شد.' });
            }
        } catch (e) {
            Swal.fire({ icon: 'error', title: 'خطا در حذف فایل' });
        }
    };

    const AnswerPreviewModal = () => {
        if (!selectedQuestionAnswer) return null;
        const files = getAnswerFiles(selectedQuestionAnswer);
        const hasAnswerText = !!(selectedQuestionAnswer.answer && selectedQuestionAnswer.answer.trim());
        const hasFiles = files.length > 0;
        const isUnanswered = !hasAnswerText && !hasFiles;

        const closeModal = () => {
            setSelectedQuestionAnswer(null);
            setActivePreviewBtn(null);
            setPreviewFile(null);
        };

        const content = isUnanswered ? (
            <p className={classes.examInfo__answerModal_empty}>پاسخی ثبت نشده است.</p>
        ) : (
            <div className={classes.examInfo__answerModal_contentInner}>
                {hasAnswerText && (
                    <div className={classes.examInfo__answerModal_section}>
                        <h4 className={classes.examInfo__answerModal_sectionTitle}>متن پاسخ</h4>
                        <div className={classes.examInfo__answerModal_text} dangerouslySetInnerHTML={{ __html: selectedQuestionAnswer.answer }} />
                    </div>
                )}
                {hasFiles && (
                    <div className={classes.examInfo__answerModal_section}>
                        <h4 className={classes.examInfo__answerModal_sectionTitle}>فایل‌های آپلود شده</h4>
                        <div className={classes.examInfo__answerModal_filesGrid}>
                            {files.map((file) => (
                                <div key={file.id || file.path} className={classes.examInfo__answerModal_fileCard}>
                                    <span
                                        className={classes.examInfo__answerModal_fileName}
                                        onClick={() => setPreviewFile(file)}
                                        title="مشاهده"
                                    >
                                        {getDisplayFileName(file)}
                                    </span>
                                    <div className={classes.examInfo__answerModal_fileActions}>
                                        <button
                                            type="button"
                                            className={classes.examInfo__answerModal_fileAction}
                                            onClick={() => setPreviewFile(file)}
                                            title="مشاهده"
                                        >
                                            <Eye width={16} height={16} />
                                        </button>
                                        {file.id && (
                                            <button
                                                type="button"
                                                className={classes.examInfo__answerModal_fileAction}
                                                onClick={() => handleFileDelete(file)}
                                                title="حذف"
                                            >
                                                <Delete width={16} height={16} />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );

        return ReactDOM.createPortal(
            <>
                <div className={classes.examInfo__answerBackdrop} onClick={closeModal} />
                <div className={classes.examInfo__answerModal} onClick={(e) => e.stopPropagation()}>
                    <div className={classes.examInfo__answerModal_header}>
                        <h3>پاسخ سوال {selectedQuestionAnswer.quNo}</h3>
                        <button className={classes.examInfo__answerModal_close} onClick={closeModal}>بستن</button>
                    </div>
                    <div className={classes.examInfo__answerModal_content}>{content}</div>
                </div>
                {previewFile && (
                    <RemoteFilePreviewModal file={previewFile} onClose={() => setPreviewFile(null)} isNested />
                )}
            </>,
            document.getElementById("backdrop-root")
        );
    };

    return (
        <div className={`${classes.appContainer} ${classes.examAppContainer}`} style={{ minHeight: "100vh", height: "100%" }}>
            <AnswerPreviewModal />
            <div className={classes.container}>
                {!isLoading ?
                    <>
                        <header className={classes.timeRemainedContainer} style={{ display: 'grid' }}>
                            <div className={classes.headerBox} >
                                {currentAttempt ? (
                                    <ExamInfoCountdown currentAttempt={currentAttempt} examData={examData} />
                                ) : (
                                    <div className={classes.countdownContainer}>
                                        <svg id={classes.circle_container} viewBox="2 -2 28 36" xmlns="http://www.w3.org/2000/svg">
                                            <circle id={classes.circle_container__background} r="16" cx="16" cy="16" shapeRendering="geometricPrecision"></circle>
                                        </svg>
                                        <div className={classes.timeRemained} style={{ zIndex: 1 }}>
                                            <div id={classes.time} style={{ color: '#9C9C9C' }}>--:--:--</div>
                                            <div style={{ color: '#9C9C9C' }}>مانده</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData?.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li className={classes.userIdentityItem}>
                                            <span>{`نام کاربر : ${headerDisplayName}`}</span>
                                            {isUserLogged && (
                                                <button
                                                    type="button"
                                                    className={classes.logoutIconBtn}
                                                    onClick={handleLogout}
                                                    title="خروج از حساب کاربری"
                                                >
                                                    <Exit fill="#fff" width="14px" height="14px" />
                                                </button>
                                            )}
                                        </li>
                                        <li>{`مدت آزمون : ${examData?.duration ? examData.duration + ' دقیقه ' : 'نامحدود'}`}</li>
                                        <li>{`نوع آزمون : ${getQuizTypeLabel(examData?.type)}`}</li>
                                        {
                                            examData?.type !== "mixed" && (
                                                examData?.test_type === "score" ?
                                                    <li>{`نمره کل : ${examData.total_score}`}</li>
                                                    : <li>{`ضریب منفی : ${examData?.negative_point ? examData?.negative_point.replace("/", " به ") : "ندارد"}`}</li>
                                            )
                                        }
                                        <li>{`تعداد سوالات : ${examData.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : ${currentAttempt ? currentAttempt.answered_questions : 0}`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>{`پاسخ داده نشده : ${currentAttempt ? currentAttempt.unanswered_questions : (examData?.number_of_question ?? 0)}`}</p>
                                    </div>
                                </div>
                                <div className={classes.answerSheet}>
                                    <ol>
                                        {
                                            (attemptQuizData?.questions || examData?.questions || []).map((data, idx) => {
                                                const question = typeof data === 'object' ? data : { id: data, question_number: idx + 1, options: [], score: 0, type: examData?.type === 'test' ? 'test' : 'descriptive' };
                                                if (examData.type === "test" || (examData.type === "mixed" && isTestQuestion(question))) {
                                                    return (
                                                        <TestCheckboxPreviewButtons
                                                            key={question.id}
                                                            id={question.id}
                                                            quNo={question.question_number ?? (idx + 1)}
                                                            options={question.options || []}
                                                            score={question.score || 0}
                                                            isRank={examData?.test_type}
                                                            quizType={examData?.type}
                                                            isInfo
                                                            userAnswered={userAnswered}
                                                        />
                                                    );
                                                }

                                                return (
                                                    <PreviewUploadButtons
                                                        key={question.id}
                                                        index={question.id}
                                                        quNo={question.question_number}
                                                        options={question.options || []}
                                                        score={question.score || 0}
                                                        isInfo
                                                        userAnswered={userAnswered}
                                                        onQuestionClick={(answer) => { setSelectedQuestionAnswer(answer); setActivePreviewBtn(question.id); }}
                                                        activeBtn={activePreviewBtn}
                                                    />
                                                );
                                            })
                                        }
                                    </ol>
                                </div>
                            </div>
                            {/* DISPLAY QUESTION / QUESTION SECTION  */}
                            <section section className={classes.questionSection} style={{ maxWidth: "unset" }}>
                                <div className={classes.questionSection_header} style={{ alignItems: "center" }}>
                                    <h2>اطلاعات آزمون</h2>
                                    <div id={classes.returnBtn}>
                                    </div>
                                </div>
                                <div className={`${classes.questionContainer} ${classes.examInfo__container}`} >
                                    {
                                        <div style={{ width: "100%" }} key={examData?.id}>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نام شرکت کننده :</p>
                                                <p className={classes.examInfo__detail}>{participantDisplayName}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نام آموزشگاه :</p>
                                                <p className={classes.examInfo__detail}>{schoolName}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>عنوان آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.title}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>تعداد سوالات :</p>
                                                <p className={classes.examInfo__detail}>{examData?.number_of_question}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نوع آزمون :</p>
                                                <p className={classes.examInfo__detail}>{getQuizTypeLabel(examData?.type)}</p>
                                            </div>
                                            {examData?.type === "mixed" && mixedQuestionCounts && (
                                                <>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>تعداد سوالات تستی :</p>
                                                        <p className={classes.examInfo__detail}>{mixedQuestionCounts.test}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>تعداد سوالات تشریحی :</p>
                                                        <p className={classes.examInfo__detail}>{mixedQuestionCounts.descriptive}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>نحوه تصحیح :</p>
                                                        <p className={classes.examInfo__detail}>سوالات تستی خودکار و سوالات تشریحی توسط مصحح</p>
                                                    </div>
                                                </>
                                            )}
                                            {examData?.type !== "mixed" && (
                                                <div className={classes.examInfo__info_container}>
                                                    <p className={classes.examInfo__title}>ضریب منفی تست :</p>
                                                    <p className={classes.examInfo__detail}>{examData?.negative_point ? examData?.negative_point : "ندارد"}</p>
                                                </div>
                                            )}
                                            {
                                                examData?.date &&
                                                <div className={classes.examInfo__info_container}>
                                                    <p className={classes.examInfo__title}>تاریخ ورود آزمون :</p>
                                                    <p className={classes.examInfo__detail}>{examData?.date}</p>
                                                </div>
                                            }
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>شروع و ورود آزمون :</p>
                                                {examData?.start_time_from == null ? <p className={classes.examInfo__detail}>هر ساعتی</p> :
                                                    <p className={classes.examInfo__detail}>{`${examData?.start_time_from} تا ${examData?.start_time_to}`}</p>}
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>پایان آزمون :</p>
                                                <p className={classes.examInfo__detail}>{formatQuizEndDescription(examData)}</p>
                                            </div>
                                            {examData?.type !== "mixed" && handleResultShow()}
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>امکان ترک آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.leave === 0 ? "ندارد" : "دارد"}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>فعال بودن آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.active === 0 ? "غیر فعال" : "فعال"}</p>
                                            </div>

                                            {examData?.question_type === "custom" && (
                                                <>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>ترتیب نمایش سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getQuestionOrderText()}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>نحوه نمایش سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getQuestionDisplayText()}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>نحوه جابجایی بین سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getNavigationText()}</p>
                                                    </div>
                                                    {(examData?.questions_display_mode === "one_by_one" && examData?.question_navigation_mode === "forward_only") && (
                                                        <div className={classes.examInfo__info_container}>
                                                            <p className={classes.examInfo__title}>هشدار مهم :</p>
                                                            <p className={classes.examInfo__detail} style={{ color: "#b45309" }}>
                                                                این آزمون بدون امکان بازگشت به سوالات قبلی است. پس از رفتن به سوال بعد، امکان بازبینی سوالات قبل را نخواهید داشت.
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        // ))
                                    }
                                    {/* <div className={classes.examInfo__login_section} style={{ display: isUserLogged ? "none" : "flex" }}>
                                        <form className={classes.examInfo__login} onSubmit={onSubmitHandler} >
                                            <div className={classes.examInfo__login_title}>
                                                <h3>ورود</h3>
                                            </div>
                                            <div className={classes.examInfo__login_title}>
                                                <p className={classes.examInfo__login_info}>لطفا وارد حساب کاربری خود شوید</p>
                                            </div>
                                            <input type="number" placeholder='شماره تلفن' name='phone' value={inputField.phone} onChange={inputHandler} className={classes.examInfo__login_input} />
                                            <input type="password" placeholder='رمز عبور' name='password' value={inputField.password} onChange={inputHandler} className={classes.examInfo__login_input} style={{ marginBottom: "6px" }} />
                                            <p id={classes.forgetPassword} style={{ margin: "0px 0 16px 0" }}>فراموشی رمز عبور</p>
                                            <button type="submit" className={classes.examInfo__login_btn}>ورود</button>
                                            {verify.guest ? <p id={classes.forgetPassword} className={classes.examInfo__changeField} onClick={() => navigate(`/guest/join/${params.quiz}`)} >ورود به صورت مهمان</p> : <></>}
                                        </form>
                                    </div> */}
                                </div>
                                <div className={classes.examInfo__btn_container}>
                                    {isGuestLink ? (
                                        <button
                                            type="button"
                                            disabled={isJoinExamLoading}
                                            onClick={() => handleGuestEntryClick()}
                                            className={classes.examInfo__btn_secondary}
                                        >
                                            <span className={classes.examInfo__btnInner}>
                                                {isJoinExamLoading && <span className={classes.examInfo__btnSpinner} />}
                                                {isJoinExamLoading ? 'لطفاً صبر کنید…' : 'ورود به آزمون'}
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            disabled={isJoinExamLoading}
                                            onClick={() => examPageHandler()}
                                            className={classes.examInfo__btn}
                                        >
                                            <span className={classes.examInfo__btnInner}>
                                                {isJoinExamLoading && <span className={classes.examInfo__btnSpinner} />}
                                                {isJoinExamLoading ? 'لطفاً صبر کنید…' : 'ورود به آزمون'}
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </section>
                        </main>
                    </>

                    :
                    <>
                        <Loading />
                    </>
                }
            </div>
        </div >
    );
}

export default ExamInfo;

// <section section className={classes.questionSection} style={{maxWidth:"unset"}}>
//                         <div className={classes.questionSection_header} style={{ alignItems: "center" }}>
//                             <h2>اطلاعات آزمون</h2>
//                             <div id={classes.returnBtn}>
//                                 <p>بازگشت به سایت</p>
//                                 <div className={classes.exitIcon}>
//                                     <Exit fill='#fff' width="15px" height='15px' />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className={`${classes.questionContainer} ${classes.examInfo__container}`} >
//                             {
//                                 <div style={{ width: "100%" }} key={examData?.id}>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>نام شرکت کننده :</p>
//                                         <p className={classes.examInfo__detail}>{isUserLogged ? LS_data.name : "وارد حساب کاربری خود نشده اید."}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>نام آموزشگاه :</p>
//                                         <p className={classes.examInfo__detail}>{schoolName}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>عنوان آزمون :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.title}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>تعداد سوالات :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.number_of_question}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>نوع آزمون :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.type == "test" ? "تست" : "تشریحی"}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>ضریب منفی تست :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.negative_point ? examData?.negative_point : "ندارد"}</p>
//                                     </div>
//                                     {
//                                         examData?.date &&
//                                         <div className={classes.examInfo__info_container}>
//                                             <p className={classes.examInfo__title}>تاریخ ورود آزمون :</p>
//                                             <p className={classes.examInfo__detail}>{examData?.date}</p>
//                                         </div>
//                                     }
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>شروع و ورود آزمون :</p>
//                                         {examData?.start_time_from == null ? <p className={classes.examInfo__detail}>هر ساعتی</p> :
//                                             <p className={classes.examInfo__detail}>{`${examData?.start_time_from} تا ${examData?.start_time_to}`}</p>}
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>پایان آزمون :</p>
//                                         <p className={classes.examInfo__detail}>{`${examData?.duration ? examData?.duration + " دقیقه بعد از شروع آزمون" : "نامحدود"}`}</p>
//                                     </div>
//                                     {
//                                         handleResultShow()
//                                     }

//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>امکان ترک آزمون :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.leave == 0 ? "ندارد" : "دارد"}</p>
//                                     </div>
//                                     <div className={classes.examInfo__info_container}>
//                                         <p className={classes.examInfo__title}>فعال بودن آزمون :</p>
//                                         <p className={classes.examInfo__detail}>{examData?.active == 0 ? "غیر فعال" : "فعال"}</p>
//                                     </div>
//                                 </div>
//                                 // ))
//                             }
//                             <div className={classes.examInfo__login_section} style={{ display: isUserLogged ? "none" : "flex" }}>
//                                 <form className={classes.examInfo__login} onSubmit={onSubmitHandler} >
//                                     <div className={classes.examInfo__login_title}>
//                                         <h3>ورود</h3>
//                                     </div>
//                                     <div className={classes.examInfo__login_title}>
//                                         <p className={classes.examInfo__login_info}>لطفا وارد حساب کاربری خود شوید</p>
//                                     </div>
//                                     <input type="number" placeholder='شماره تلفن' name='phone' value={inputField.phone} onChange={inputHandler} className={classes.examInfo__login_input} />
//                                     <input type="password" placeholder='رمز عبور' name='password' value={inputField.password} onChange={inputHandler} className={classes.examInfo__login_input} style={{ marginBottom: "6px" }} />
//                                     <p id={classes.forgetPassword} style={{ margin: "0px 0 16px 0" }}>فراموشی رمز عبور</p>
//                                     <button type="submit" className={classes.examInfo__login_btn}>ورود</button>
//                                     {verify.guest ? <p id={classes.forgetPassword} className={classes.examInfo__changeField} onClick={() => navigate(`/guest/join/${params.quiz}`)} >ورود به صورت مهمان</p> : <></>}
//                                 </form>
//                             </div>
//                         </div>
//                         <div className={classes.examInfo__btn_container}>
//                             <button onClick={() => examPageHandler()} className={classes.examInfo__btn}>شروع  آزمون و مشاهده سوالات</button>
//                         </div>
//                     </section>